export function PrivacyPolicy() {
  return (
    <div className="h-full overflow-y-auto">
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl font-bold mb-6">Privacy Policy for WarYes</h1>

          <div className="space-y-6 text-foreground">
            <p>
              This Privacy Policy governs the manner in which WarYes collects, uses,
              maintains, and discloses information collected from users (each, a
              "User") of the war-yes.com or waryes.com website ("Site"). This privacy policy
              applies to the Site and all products and services offered by WarYes.
            </p>

            <section>
              <h2 className="text-2xl font-semibold mb-3">Personal identification information</h2>
              <p>
                We may collect personal identification information from Users when they
                authenticate with our Site using Discord OAuth. When you authenticate
                through Discord, we collect your Discord ID, username, and email address
                (if provided by Discord). We will collect personal identification
                information from Users only if they voluntarily authenticate with our
                Site. Users can always choose not to authenticate, except that it may
                prevent them from engaging in certain Site-related activities that
                require authentication.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-3">Non-personal identification information</h2>
              <p>We don't collect any non-personal identification information.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-3">Web browser cookies and local storage</h2>
              <p>
                WarYes may use your browser&apos;s local storage for preferences and
                limited client-side state needed for the Site to work as you expect. We
                also use HTTP-only cookies for authentication to maintain your login
                session. These cookies are essential for the Site to function and are
                not used for cross-site tracking or advertising.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-3">How we use collected information</h2>
              <p>
                WarYes may collect and use Users' personal information for the following
                purposes:
              </p>
              <ul className="list-disc pl-6 space-y-2 mt-2">
                <li>
                  <strong>To store and display user-generated content:</strong> We use the
                  decks and division analysis that Users create and store on our Site to
                  display them to other Users and to facilitate sharing of this content.
                </li>
                <li>
                  <strong>To provide authentication and authorization:</strong> We use your
                  Discord ID and username to authenticate you and determine your access
                  level to certain features of the Site.
                </li>
                <li>
                  <strong>To respond to inquiries:</strong> We may use the email address
                  associated with your Discord account to respond to inquiries, questions,
                  and/or other requests.
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-3">Data Retention</h2>
              <p>
                WarYes will retain user data, including personal information, decks, and
                division analysis, for as long as the user maintains an authenticated
                session with us. Upon request or account deletion, WarYes will remove all
                personal information and data associated with the account. This includes any
                user-generated content, such as decks and division analysis, that may have
                been stored on our Site. Please note that once this information is deleted,
                it cannot be recovered.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-3">How we protect your information</h2>
              <p>
                We adopt appropriate data collection, storage, and processing practices
                and security measures intended to protect against unauthorized access,
                alteration, disclosure, or destruction of your personal information and
                data stored on our Site, including technical and organizational controls
                appropriate to the nature of the data we hold.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-3">Sharing your personal information</h2>
              <p>
                We do not sell, trade, or rent Users' personal identification
                information to others.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-3">Data Storage</h2>
              <p>
                By using our Site, you acknowledge that the personal information and
                user-generated content described in this policy may be stored and
                processed on systems under our control, using safeguards we consider
                appropriate for that purpose. This policy describes what we collect and
                why; it is not a technical architecture document.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-3">Changes to this privacy policy</h2>
              <p>
                WarYes has the discretion to update this privacy policy at anytime. We
                encourage Users to frequently check this page for any changes to stay
                informed about how we are helping to protect the personal information
                we collect. You acknowledge and agree that it is your responsibility
                to review this privacy policy periodically and become aware of
                modifications.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-3">Your acceptance of these terms</h2>
              <p>
                By using this Site, you signify your acceptance of this policy. If you
                do not agree to this policy, please do not use our Site. Your
                continued use of the Site following the posting of changes to this
                policy will be deemed your acceptance of those changes.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-3">Your right to complaint</h2>
              <p>
                If you wish to complain to a supervisory authority, you can do so by
                complaining to the ICO in the UK. You can find out more about your
                rights and how to complain to the ICO here:{" "}
                <a
                  href="https://ico.org.uk/concerns/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary hover:underline"
                >
                  https://ico.org.uk/concerns/
                </a>
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-3">Contacting us</h2>
              <p>
                If you have any questions about this Privacy Policy, the practices of
                this site, or your dealings with this site, please contact us at{" "}
                <a
                  href="mailto:support@war-yes.com"
                  className="text-primary hover:underline"
                >
                  support@war-yes.com
                </a>
                .
              </p>
            </section>

            <p className="text-sm text-muted-foreground mt-8">
              This document was last updated on April 13, 2026.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}










